module.exports = __webpack_public_path__ + "img/2025big25.024ecbf9.jpg";